export const globalRem = (baseWidth, baseHeight) => {
	var ratioW, ratioH, remStyle;
	var html = document.getElementsByTagName("html")[0];
	// 使用 viewport 的大小 http://weizhifeng.net/viewports.html
	// https://github.com/jquery/jquery/blob/master/src/dimensions.js
	if(!baseWidth){
		html.className = html.className.replace(/root-rem/, '');
		window.removeEventListener("resize", globalRem);
		return;
	}
	if (baseWidth) {
		// 获取浏览器窗口文档显示区域的宽度，不包括滚动条
		ratioW = document.documentElement.clientWidth / baseWidth;
	}
	if (baseHeight) {
		// 获取浏览器窗口文档显示区域的高度，不包括滚动条
		ratioH = document.documentElement.clientHeight / baseHeight;
	}
	if(!document.getElementById('rootRemStyle')){
		remStyle = document.createElement('style');
		remStyle.id = 'rootRemStyle';
		remStyle.setAttribute('type', 'text/css');
		document.head.appendChild(remStyle);
	} else {
		remStyle = document.getElementById('rootRemStyle');
	}
	var MAX_RATIO = 1.5;
	if (ratioW || ratioH) {
		var ratio = Math.min(ratioW || MAX_RATIO, ratioH || MAX_RATIO);
		if (ratio > MAX_RATIO) {
			ratio = MAX_RATIO;
		}
		if (remStyle) {
			remStyle.innerText = `.root-rem {font-size: ${(100 * ratio)}px;}`;
		}
		if (html.className.indexOf('root-rem') <= -1) {
			html.className += 'root-rem';
		}
	}
	window.addEventListener("resize", globalRem);
}